import React, { memo } from "react";
import classNames from "classnames";

//constants
import { TEXTS, UPI_TIMER_CONTENT_V4 } from "@payment-ui/constants/Upi";

// test-ids
import { UPI_TIMER_TEST_IDS, UPI_INTENT_TEST_IDS } from "@swiggy-private/payment-test-ids";

//styles
import styles from "../styles.scss";

function Note({ isIntent = false, isJioHotstarFlow = false }: { isIntent?: boolean; isJioHotstarFlow?: boolean }) {
    const TEST_ID = isIntent ? UPI_INTENT_TEST_IDS : UPI_TIMER_TEST_IDS;

    return (
        <div
            className={classNames(styles.containerContentMeta, {
                [styles.containerContentMetaisJhs]: isJioHotstarFlow,
            })}
            data-testid={TEST_ID.META}
        >
            <span className={styles.containerContentMetaNote}>{TEXTS.NOTE}</span>
            {UPI_TIMER_CONTENT_V4.META}
        </div>
    );
}

export default memo(Note);
